import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getNewStoreData } from './helper/util';
import { Box, Typography } from '@mui/material';
import ConsentPage from 'pages/ConsentPage';
import RestrictedPage from './pages/RestrictedPage';

const App: React.FC = () => {
  const { accessToken, storeId } = getNewStoreData();

  if (!accessToken || !storeId) {
    return (
      <Box p={4}>
        <Typography color="error" variant="body1">
          Missing authentication or store context.
        </Typography>
      </Box>
    );
  }

  return (
    <Router>
      <Routes>
        {/* <Route
          path="/"
          element={
            <MenuPage />
          }
        /> */}
        <Route path="/" element={<ConsentPage />} />
        <Route path="/restricted" element={<RestrictedPage />} />
      </Routes>
    </Router>
  );
};

export default App;
